export default __webpack_public_path__ + "static/media/hand-coin.99a79fa0.svg";